const o=(o,r)=>r&&"number"==typeof o?r.transform(o):o;export{o as getValueAsType};
